import { render, staticRenderFns } from "./copefeed.vue?vue&type=template&id=2010bb55&scoped=true&"
import script from "./copefeed.vue?vue&type=script&lang=js&"
export * from "./copefeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010bb55",
  null
  
)

export default component.exports